import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import InputSearch from "components/molecules/InputSearch";
import config from "config";
import { QUERY_PARAMS } from "constants/URL";
import { debugModeArgument } from "utils/debugModeArgument";

/**
 * Molecule for Textsearch
 */
const SearchBar = ({
  actionUrl = "./",
  forceFormSubmit = false,
  hiddenFilters = [],
  textFilter = {
    name: "q",
  },
  onFormSubmit,
  onQueryChange,
  onSuggestionsRequest,
  suggestions,
}) => {
  const [valueBeforeSuggestion, setValueBeforeSuggestion] = useState("");
  const formRef = useRef(null);

  const handleFilterChange = (name, value, valueBeforeSuggestion = "") => {
    if (forceFormSubmit) {
      onFormSubmit(value, formRef.current);
    } else {
      onQueryChange(name, value, valueBeforeSuggestion);
    }
  };

  const onSearch = (newValue, valueBeforeSuggestion = "") => {
    setValueBeforeSuggestion(valueBeforeSuggestion);
    handleFilterChange(textFilter.name, newValue, valueBeforeSuggestion);
  };

  const componentClass = "sal-searchbar";

  return (
    <search>
      <form
        ref={formRef}
        className={componentClass}
        action={actionUrl}
        method="get"
        aria-label="Suchform"
        role="search"
        data-cv-debug={debugModeArgument("true")}
        data-cv-debug-system={debugModeArgument("SAL")}
        data-cv-debug-component={debugModeArgument("Searchbar")}
      >
        <InputSearch
          {...textFilter}
          suggestions={suggestions}
          onSuggestionsRequest={onSuggestionsRequest}
          isFormSubmit={forceFormSubmit}
          onSearch={onSearch}
          removeInitialValue={config.removeInitialValue}
          allowEmptySearch={config.allowEmptySearch}
        />
        {config.webcodes.enabled && forceFormSubmit && (
          <input type="hidden" name={QUERY_PARAMS.SKIP_WEBCODE} value="" />
        )}
        {forceFormSubmit && (
          <input
            type="hidden"
            name={QUERY_PARAMS.IS_USER_SEARCH}
            value="true"
          />
        )}
        {forceFormSubmit && valueBeforeSuggestion !== "" && (
          <input
            type="hidden"
            name={QUERY_PARAMS.VALUE_BEFORE_AUTOSUGGEST}
            value={valueBeforeSuggestion}
          />
        )}
        {hiddenFilters.map((filter, index) => (
          <input
            key={index}
            type="hidden"
            name={filter.name}
            value={filter.value}
          />
        ))}
      </form>
    </search>
  );
};

SearchBar.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  forceFormSubmit: PropTypes.bool,
  hiddenFilters: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ),
  onFormSubmit: PropTypes.func,
  onQueryChange: PropTypes.func,
  onSuggestionsRequest: PropTypes.func,
  suggestions: PropTypes.shape({
    loading: PropTypes.bool,
    terms: PropTypes.array,
  }),
  textFilter: PropTypes.shape({
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onMountStateChange: PropTypes.func.isRequired,
  }),
};

export default SearchBar;
